import * as $ from 'jquery';
import * as ko from 'knockout';

declare var DobryKantor: any;
declare var Hammer: any;

export class OpinionsNordiqaComponent {
    opinions: ko.ObservableArray<any>;
    index: ko.Observable<number>;
    opinion: ko.Computed<any>;
    opinion_2: ko.Computed<any>;
    opinion_3: ko.Computed<any>;
    timer: any;
    timerStopped: boolean = false;
    opinionElement: ko.Observable<HTMLElement>;

    executeTimer() {
        if (!this.timerStopped) {
            this.timer = setTimeout(() => {
                this.next(false);
                this.executeTimer();
            }, 5000);
        }
    }

    constructor() {
        this.opinionElement = ko.observable(null as HTMLElement);
        this.index = ko.observable(0);
        this.opinions = ko.observableArray([
            {
                text: "Jestem bardzo zadowolona z obsługi, bo Pani przez telefon pokierowała mnie co i jak. Cała wymiana szybciej jak w zwykłym kantorze czy banku, nie mówiąc już o tym ile więcej zostało w mojej kieszeni.",
                signature: "Asia"
            },
            {
                text: "Od kilku lat wymieniałem w banku bo tak wydawało mi się łatwiej, znajomy poradził mi spróbować przez internetowy kantor, wybrałem ten bo miał najlepszy kurs NOKa – nawet nie chce myśleć ile straciłem przez te lata.",
                signature: "MarciN K."
            },
            {
                text: "Dostałem namiary na NORDIQA od znajomego, bałem się, więc zacząłem od małej kwoty. Zaokrąglając czekałem na przelew 15 minut.",
                signature: "MG"
            },
            {
                text: "Podoba mi się strona, przejrzystość i szybka wymiana. Oczywiście kursy też muszą być dobre, ale te dodatki sprawiają, że chce do Was wracać.",
                signature: "Alicja"
            },
            {
                text: "Szybko, sprawnie, bez zbędnych ceregieli, a pan na słuchawce konkretny. Wymieniałem szwedzką koronę na świetnych warunkach. ",
                signature: "julian"
            },
            {
                text: "Wysyłam przez nich pieniądze rodzinie w Polsce. Mam do nich pełne zaufanie – bo zawsze mam szybki odzew na kontakt z mojej strony. ",
                signature: "MAX"
            },
            {
                text: "Lubie takie podejście do sprawy – dzwonie i od razu wiem co i jak. Polecam wszystkim znajomym pracującym za granicą.",
                signature: "Łucja R."
            },
            {
                text: "Ale byłem zaskoczony jak z mojego banku ING w Holandii przelew w EUR doszedł do nich w godzinę. Dla mnie rewelacja, bo szybko, tanio i czuje się pewnie. ",
                signature: "Patryk"
            },
            {
                text: "Z Norwegii zasilam konto i od razu wymieniam na moje konto w Polsce, najdłużej idzie przelew z Norwegii ale sama wymiana to express a ja nie musze latać po kantorach.",
                signature: "Emilia"
            }
        ]);

        this.opinion = ko.computed(() => {
            return this.opinions()[this.index()];
        });

        this.opinion_2 = ko.computed(() => {
            return this.opinions()[(this.index() + 1) % this.opinions().length];
        });

        this.opinion_3 = ko.computed(() => {
            return this.opinions()[(this.index() + 2) % this.opinions().length];
        });

        this.executeTimer();

        var hammertime = new Hammer($('#co-mowia-nasi-klienci-dk').get(0), {});
        hammertime.on('swiperight', ev => {
            this.prev(true);
        });

        hammertime.on('swipeleft', ev => {
            this.next(true);
        });
    }

    prev(stopTimer: boolean) {
        this.hide();
        if (stopTimer) {
            this.timerStopped = true;
            clearTimeout(this.timer);
        }

        let newIndex = (this.index() + 1) % this.opinions().length;
        this.index(newIndex);
        this.fadeIn();
    }

    next(stopTimer: boolean) {
        this.hide();
        if (stopTimer) {
            this.timerStopped = true;
            clearTimeout(this.timer);
        }

        let newIndex = (this.index() + 1) % this.opinions().length;
        this.index(newIndex);
        this.fadeIn();
    }

    hide() {
        if (this.opinionElement() != null) {
            $(this.opinionElement()).addClass('zero-opacity').removeClass('full-opacity')
                .removeClass('fade-in-animation');
        }
    }

    fadeIn() {
        if (this.opinionElement() != null) {
            $(this.opinionElement()).delay(1)
                .addClass('fade-in-animation').addClass('full-opacity').removeClass('zero-opacity');
        }
    }
}
